import { getNameInfo } from "../utilities/getNameInfo.js";
// eslint-disable-next-line jsdoc/require-jsdoc
export async function appendArrayBuffer(fileCollection, relativePath, arrayBuffer, options = {}) {
    const source = await getExtendedSourceFromArrayBuffer(relativePath, arrayBuffer, options);
    await fileCollection.appendExtendedSource(source);
}
async function getExtendedSourceFromArrayBuffer(originalRelativePath, arrayBuffer, options = {}) {
    const { name, relativePath } = getNameInfo(originalRelativePath);
    const blobInput = await arrayBuffer;
    // Types of property [Symbol.toStringTag] are incompatible.
    // Type SharedArrayBuffer is not assignable to type ArrayBuffer
    // @ts-expect-error Blob doesn't explicitly accept ArrayBufferLike but that should work.
    const blob = new Blob([blobInput], {
        type: 'application/octet-stream',
    });
    return {
        uuid: crypto.randomUUID(),
        relativePath,
        name,
        lastModified: options.dateModified || Date.now(),
        baseURL: 'ium:/',
        extra: options.extra,
        text: () => blob.text(),
        stream: () => blob.stream(),
        arrayBuffer: () => blob.arrayBuffer(),
    };
}
//# sourceMappingURL=appendArrayBuffer.js.map